import { render, staticRenderFns } from "./AppSignupOneTimePassPage.vue?vue&type=template&id=885f617e"
import script from "./AppSignupOneTimePassPage.vue?vue&type=script&lang=ts"
export * from "./AppSignupOneTimePassPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports